///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import Tooltip from "../Tooltip";
import Spinner from "../icons/Spinner";

export const IconButton = ({
  title,
  disabled,
  dataTestId,
  onClick,
  inProgress = false,
  icon: Icon,
  viewBox,
  show = true,
  className = "fr mt-8 ml-12",
  iconProps,
  ...rest
}) => (
  <>
    {show && (
      <Tooltip
        content={title}
        placement="bottom-end"
        offset={[11, 6]}
        {...rest}
      >
        <span className={className}>
          <button
            data-testid={dataTestId}
            id={dataTestId}
            onClick={onClick}
            className="no-focus"
            disabled={disabled || inProgress}
          >
            {inProgress ? (
              <Spinner className="spinner" height="16px" width="16px" />
            ) : (
              <Icon
                height="16px"
                width="16px"
                title=""
                fill={disabled ? "#ADAFB2" : "#343434"}
                viewBox={viewBox}
                {...iconProps}
              />
            )}
          </button>
        </span>
      </Tooltip>
    )}
  </>
);

export default IconButton;
